// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import { callAPI, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import { useDispatch } from "react-redux";
// import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
// import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
// import { openPopUp } from "../../Components/Dialog/OpenNewModal";
// import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
// import WSButton from "../../Components/Button/WSButton";
// import AddIcon from "@mui/icons-material/Add";
// import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
// import CashInHand from "./CashInHand";


// export const CashInHandList: React.FC<any> = React.memo((props) => {

//   const [selectedId, setSelectedId] = useState<number | null>(null);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const dispatch = useDispatch();
//   const { showMessage } = useSnackbar();
//   const navigate = useNavigate();

//   const params = useParams();
//   const id = params?.id;

//   const filters = ["All Records"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   useEffect(() => {
//     updateMainHeader("Cash In Hand");
//   });

//   breadCrumbsStore.updateBreadCrumbs([
//     { "Cash In Hand List": "/cash-in-hand/list" },
//   ]);


//   const columns: IColumns[] = [
//     {
//       header: "Name",
//       fieldName: "specializations",
//       tooltip: true,
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit", "Delete"],
//     },
//   ];

//   const handleClick = () => {
//     openPopUp(metadata, handleData, "60rem");
//   };

//   const handleData = async (data: any) => {
//     console.log('data are ',data);
//     // try {
//     //   setLoading(true);

//     //   const request = {
//     //     CategoryName: data.name,
//     //   };

//     //   let response;

//     //   if (id) {
//     //     response = await callAPI(
//     //       `Vyapar/Category/${id}`,
//     //       Method.PUT,
//     //       request
//     //     );
//     //   } else {
//     //     response = await callAPI(
//     //       "Vyapar/Category",
//     //       Method.POST,
//     //       request
//     //     );
//     //   }

//     //   console.log('handleData response===>', response);
//     //   if (response) {
//     //     showMessage(
//     //       response?.message,
//     //       response.success === true ? "success" : "error"
//     //     );

//     //     if (response.success === true) {
//     //       navigate("/category/list");
//     //     }
//     //   }
//     // } catch (error) {
//     //   console.error("Failed to save user:", error);
//     // } finally {
//     //   setLoading(false);
//     // }
//   };

//   const metadata: IMetaData = {
//     title: "Cash In Hand",
//     hideActions: false,
//     content: (props: any, row: any) => (
//       <CashInHand {...props} />
//     ),
//     actions: [
//       {
//         label: "Cancel",
//         // onClick: handleCloseDialog,
//         className: "ws-cancel",
//         type: "button",
//       },
//       {
//         label: "Save",
//         type: "submit",
//         onClick: handleData,
//         autoFocus: true,
//       },
//     ],
//     isDragable: true,
//   };
//   return (
//     <Grid p={3}>
//       <Grid container spacing={2}>

//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//             }}
//           />
//         </Grid>
//         <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
//           <WSButton
//             id="btnAddUnit"
//             label="Cash In Hand"
//             startIcon={<AddIcon />}
//             onClick={handleClick}
//             sx={{
//               borderRadius: "999px", // pill shape
//               backgroundColor: "#098963!important", // green background
//               textTransform: "none", // prevent uppercase
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": {
//                 backgroundColor: "#087654!important",
//               },
//             }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <WSDataGridNew
//             id="cashInHandGrid"
//             title="Cash In Hand"
//             columns={columns}
//             searchBox={{ fieldName: "" }}
//             addButton={{ label: "New", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// });



import { Grid } from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { callAPI, Method, updateMainHeader,dateFormat  } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import WSButton from "../../Components/Button/WSButton";
import AddIcon from "@mui/icons-material/Add";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import CashInHandWrapper from "./CashInHand"; // ← Import Wrapper
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";
import { useForm, FormProvider } from "react-hook-form";

export const CashInHandList: React.FC<any> = React.memo((props) => {
  const filters = ["All Records"];
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  const [loading, setLoading] = useState(false);

  // **CRITICAL FIX**: Use refs for immediate access (no stale closure)
  const selectedIdRef = useRef<string>("");
  const methods = useForm<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  useEffect(() => {
    updateMainHeader("Cash In Hand");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Cash In Hand List": "/cash-in-hand/list" },
  ]);

  const source = {
    url: "Vyapar/CashInHand/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  const handleAction = useCallback(async (action: string, row: any) => {
  if (action === "Edit") {
    try {
      const response = await callAPI(`Vyapar/CashInHand/${row.id}`, Method.GET);
      if (response.data) {
        const data = response.data;
        selectedIdRef.current = row.id;

        // ✅ CORRECT: data exists here
        methods.reset({
          adjustment: "CashInHand",
          amount: data.amount || 0,
          adjustmentDate: data.adjustmentDate 
            ? dateFormat(new Date(data.adjustmentDate), 'DD-MM-YYYY HH:mm:ss') 
            : dateFormat(new Date(), 'DD-MM-YYYY HH:mm:ss'),
          description: data.description || "",
        });

        setTimeout(() => {
          openPopUp(editMetadata, handleData, "60rem");
        }, 50);
      }
    } catch (error) {
      console.error("Failed to fetch cash in hand:", error);
      showMessage("Failed to fetch cash in hand data", "error");
    }
  } else if (action === "Delete") {
    selectedIdRef.current = row.id;
    setPopupOpen(true);
  }
}, [methods, showMessage]);

  const columns: IColumns[] = [
    {
      header: "Amount",
      fieldName: "amount",
    },
    {
      header: "Adjustment Date",
      fieldName: "adjustmentDate",
      tooltip: true,
      type: "date",
    },
    {
      header: "Description",
      fieldName: "description",
      tooltip: true,
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction,
    },
  ];

  const handleClick = useCallback(() => {
  selectedIdRef.current = "";
  
  // ✅ CORRECT: NO 'data' here - just default values
  methods.reset({
    adjustment: "CashInHand",
    amount: "",
    adjustmentDate: dateFormat(new Date(), 'DD-MM-YYYY HH:mm:ss'),
    description: "",
  });
  
  setTimeout(() => {
    openPopUp(createMetadata, handleData, "60rem");
  }, 100);
}, [methods]);

  const handleData = useCallback(async () => {
  try {
    setLoading(true);

    const formData = methods.getValues();
    
    // **FIXED**: Match EXACTLY your API spec
    const request = {
      adjustment: "CashInHand", // ← ADDED REQUIRED FIELD
      amount: Number(formData.amount) || 0,
      adjustmentDate: formData.adjustmentDate
        ? new Date(formData.adjustmentDate).toISOString()
        : new Date().toISOString(),
      description: formData.description || "",
    };

    console.log("ID from REF:", selectedIdRef.current, "Data:", request);

    let response;

    if (selectedIdRef.current) {
      console.log("🔄 UPDATING with ID:", selectedIdRef.current);
      response = await callAPI(
        `Vyapar/CashInHand/${selectedIdRef.current}`,
        Method.PUT,
        request
      );
    } else {
      console.log("➕ CREATING new record");
      response = await callAPI(
        `Vyapar/CashInHand`,  // ← CORRECTED (was missing slash)
        Method.POST,
        request
      );
    }

    if (response?.success === true) {
      dispatch(resetDataComponent("cashInHandGrid"));
      showMessage(response.message || "Saved successfully", "success");
    } else {
      // **ENHANCED**: Show server validation errors
      const errorMsg = response?.message || response?.data?.title || "Operation failed";
      showMessage(errorMsg, "error");
    }

  } catch (error: any) {
    console.error("Failed to save cash in hand:", error);
    
    // **BETTER ERROR HANDLING**: Show actual validation errors
    const errorMsg = error?.response?.data?.errors 
      ? JSON.stringify(error.response.data.errors) 
      : "Failed to save cash in hand";
    showMessage(errorMsg, "error");
  } finally {
    setLoading(false);
  }
}, [methods, showMessage, dispatch]);


  const createMetadata = useMemo<IMetaData>(() => ({
    title: "Cash In Hand",
    hideActions: false,
    content: () => (
      <FormProvider {...methods}>
        <CashInHandWrapper />
      </FormProvider>
    ),
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button",
      },
      {
        label: "Save",
        type: "submit",
        onClick: handleData,
        autoFocus: true,
      },
    ],
    isDragable: true,
  }), [methods, handleData]);

  const editMetadata = useMemo<IMetaData>(() => ({
    title: "Edit Cash In Hand",
    hideActions: false,
    content: () => (
      <FormProvider {...methods}>
        <CashInHandWrapper id={selectedIdRef.current} />
      </FormProvider>
    ),
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button",
      },
      {
        label: "Update",
        type: "submit",
        onClick: handleData,
        autoFocus: true,
      },
    ],
    isDragable: true,
  }), [methods, handleData]);

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        
        <Grid item xs={12}>
          <WSDataGrid
            id="cashInHandGrid"
            title="Cash In Hand"
            columns={columns}
            source={source}
            searchBox={{ fieldName: 'description' }}
            addButton={{ label: "Add New Cash", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/CashInHand"
          id={selectedIdRef.current}
          confirmMessage="Are you sure you want to delete this cash in hand record?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            console.log("Delete response:", data);
            dispatch(resetDataComponent("cashInHandGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message, "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
});
